import { defineComponent as _defineComponent } from 'vue'
interface Props {
  variant?: 'success' | 'error' | 'warning' | 'info' | 'default';
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-badge',
  props: {
    variant: { default: 'default' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})